"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyAge = exports.truncate = exports.titleCase = exports.capitalize = exports.formatAmount = exports.formatCurrency = exports.formatUSD = void 0;
const date_fns_1 = require("date-fns");
const logger_1 = require("../logger");
var currencyToLanguageCode;
(function (currencyToLanguageCode) {
    currencyToLanguageCode["USD"] = "en-US";
    currencyToLanguageCode["EUR"] = "de-DE";
    currencyToLanguageCode["COP"] = "es-CO";
    currencyToLanguageCode["GBP"] = "en-GB";
})(currencyToLanguageCode || (currencyToLanguageCode = {}));
function formatUSD(amount = 0) {
    const formattedAmount = amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return `USD ${formattedAmount}`;
}
exports.formatUSD = formatUSD;
function formatCurrency(amount = 0, currency = "USD") {
    const locate = currencyToLanguageCode[currency] || currencyToLanguageCode.USD;
    const formattedAmount = amount.toLocaleString(locate, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return `${currency} ${formattedAmount}`;
}
exports.formatCurrency = formatCurrency;
function formatAmount(amount = 0) {
    return amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
exports.formatAmount = formatAmount;
function capitalize(s) {
    if (typeof s !== "string")
        return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
}
exports.capitalize = capitalize;
function titleCase(paragraph) {
    if (paragraph) {
        return paragraph
            .toLowerCase()
            .replace(/(?:^|\s)\S/g, (res) => res.toUpperCase());
    }
    return undefined;
}
exports.titleCase = titleCase;
function truncate(paragraph, size, end = "...") {
    return `${paragraph.substring(0, size)}${end}`;
}
exports.truncate = truncate;
function prettyAge(date) {
    try {
        return (date_fns_1.formatDuration(date_fns_1.intervalToDuration({
            start: new Date(date),
            end: Date.now()
        }), { format: ["months", "days", "hours", "minutes"] })
            .replace("minutes", "m")
            .replace("minute", "m")
            .replace("hours", "h")
            .replace("hour", "h")
            .replace("days", "d")
            .replace("day", "d")
            .replace("months", "M")
            .replace("month", "M") || "Just now");
    }
    catch (error) {
        logger_1.logger.error(error);
    }
    return date;
}
exports.prettyAge = prettyAge;
//# sourceMappingURL=index.js.map